import React from 'react';

export const Button = ({ className, onClick, disabled, label, type }) => {
  return (
    <button
      type={type}
      className={className}
      onClick={onClick}
      disabled={disabled}>
      {label}
    </button>
  );
};

Button.defaultProps = {
  onClick: () => { },
  className: '',
  disabled: false,
  label: '',
  type: 'button',
};
